import { MenuIcon } from '@braskai/icons';

import { SIconButton } from './styled';

export type TBurgerButtonProps = {
  onClick: () => void;
};

export const BurgerButton = ({ onClick }: TBurgerButtonProps) => (
  <SIconButton aria-label="open sidebar" onClick={onClick}>
    <MenuIcon height={20} width={20} />
  </SIconButton>
);
